import axios from 'axios';
import {
  APP_SETTING_LOAD_EMAIL_TEMPLATES_BEGIN,
  APP_SETTING_LOAD_EMAIL_TEMPLATES_SUCCESS,
  APP_SETTING_LOAD_EMAIL_TEMPLATES_FAILURE,
  APP_SETTING_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadEmailTemplates(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_EMAIL_TEMPLATES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${
          process.env.REACT_APP_BUILDER_ENGINE
        }v${version}/projects/${projectId}/templates?templateType=${'EMAIL'}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_EMAIL_TEMPLATES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_EMAIL_TEMPLATES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEmailTemplatesError() {
  return {
    type: APP_SETTING_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_EMAIL_TEMPLATES_BEGIN:
      return {
        ...state,
        loadEmailTemplatesPending: true,
        loadEmailTemplatesError: null,
      };

    case APP_SETTING_LOAD_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        loadEmailTemplatesPending: false,
        loadEmailTemplatesError: null,
        emailTemplate: action.data,
      };

    case APP_SETTING_LOAD_EMAIL_TEMPLATES_FAILURE:
      return {
        ...state,
        loadEmailTemplatesPending: false,
        loadEmailTemplatesError: action.data.error,
      };

    case APP_SETTING_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR:
      return {
        ...state,
        loadEmailTemplatesError: null,
      };

    default:
      return state;
  }
}
